import { defineComponent as i, computed as o, useAttrs as c, createElementBlock as n, openBlock as m, mergeProps as a, unref as u } from "vue";
import { useIllustrationOptimizer as h } from "@ds/plugin";
import { omit as l } from "../../utils/omit.js";
const d = ["height", "media", "srcset", "width"], k = /* @__PURE__ */ i({
  name: "RevIllustrationSource",
  /**
   * Do not automatically inherit attributes so that we can intercept them
   * and extract what we do not want to apply (in our case `srcset`).
   */
  inheritAttrs: !1,
  __name: "IllustrationSource",
  props: {
    src: {},
    width: {},
    height: {},
    media: {}
  },
  setup(t) {
    const e = t, r = h(() => e.src), s = o(() => l(c(), ["srcset"]));
    return (p, f) => (m(), n("source", a(s.value, {
      height: t.height,
      media: t.media,
      srcset: u(r).srcset,
      width: t.width
    }), null, 16, d));
  }
});
export {
  k as default
};
